module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Slider"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms ")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Slider")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Default value")]), _vm._v(" "), _c('el-slider', {
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Customized initial value")]), _vm._v(" "), _c('el-slider', {
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Hide Tooltip")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "show-tooltip": false
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Format Tooltip")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "format-tooltip": _vm.formatTooltip
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.value5),
      callback: function($$v) {
        _vm.value5 = $$v
      },
      expression: "value5"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Breakpoints not displayed")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "step": 10
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("Breakpoints displayed")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "step": 10,
      "show-stops": ""
    },
    model: {
      value: (_vm.value7),
      callback: function($$v) {
        _vm.value7 = $$v
      },
      expression: "value7"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-slider', {
    attrs: {
      "show-input": ""
    },
    model: {
      value: (_vm.value8),
      callback: function($$v) {
        _vm.value8 = $$v
      },
      expression: "value8"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-slider', {
    attrs: {
      "range": "",
      "show-stops": "",
      "max": 10
    },
    model: {
      value: (_vm.value9),
      callback: function($$v) {
        _vm.value9 = $$v
      },
      expression: "value9"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-slider', {
    attrs: {
      "vertical": "",
      "height": "200px"
    },
    model: {
      value: (_vm.value10),
      callback: function($$v) {
        _vm.value10 = $$v
      },
      expression: "value10"
    }
  })], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3321b9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormSlider.vue
// module id = 1331
// module chunks = 2